import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { common } from "..";
import PropTypes from "prop-types";
import { vatSettlementDetailsConversion } from "./conversions";

const ReportVatSettlementSheetDetails = ({
  setDataReport 
}) => {
  const additionalData = useSelector(state => state.reports.search.additionalData);
  const navigate = useNavigate();
  const goToPrecogDetail = (documentId) => {
    let url = `precog-detail/${documentId}?from=reports&${window.location.href.split("?")[1]}`;
    return navigate(url);
  };

  const vatSettlementDetails = vatSettlementDetailsConversion(
    additionalData?.vatSettlementDetails, {}, goToPrecogDetail
  );

  useEffect(() => {
    if (vatSettlementDetails) {
      setDataReport(vatSettlementDetails);
    }
  }, [vatSettlementDetails]);

  return (
    vatSettlementDetails && (
      <common.ReportCommonTable report={vatSettlementDetails} />
    )
  );
};

ReportVatSettlementSheetDetails.propTypes = {
  objDetails: PropTypes.string.isRequired,
  setDataReport: PropTypes.func.isRequired,
  setSelectedSearch: PropTypes.func.isRequired
};

export default ReportVatSettlementSheetDetails;
